import { LoadablePaint } from '@confluence/loadable';

export const PremiumAdminFeaturesPageLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumAdminFeaturesPage" */ '../../src/ui/PremiumAdminFeaturesPage.tsx'
			)
		).PremiumAdminFeaturesPageContainer,
});
